import { Button, Loading } from '@orobix/orobix-fe-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { fetchTrainings, TrainingUuid } from './utils'

const loadingIcon = <Loading />

type SearchButtonProps = {
  isDisabled: boolean
  isLoading: boolean
  setTrainingUuid: React.Dispatch<
    React.SetStateAction<TrainingUuid | undefined>
  >
  setTrainingSearched: React.Dispatch<React.SetStateAction<boolean>>
  executionUuid?: string
}

const SearchButton = ({
  isDisabled,
  isLoading,
  setTrainingUuid,
  setTrainingSearched,
  executionUuid,
}: SearchButtonProps) => {
  const { t } = useTranslation()
  const [isFetching, setFetching] = useState(false)

  const handleClick = async () => {
    setFetching(true)
    setTrainingSearched(true)
    if (executionUuid) {
      const trainings = await fetchTrainings(executionUuid)
      if (trainings && trainings.length > 0) {
        const { product } = trainings[0]
        const { project } = product
        const training = trainings[0].id
        const trainingUuid: TrainingUuid = {
          id: training,
          product,
          project,
          executionUuid,
        }
        setTrainingUuid(trainingUuid)
      } else {
        setTrainingUuid(undefined)
      }
    }
    setFetching(false)
  }

  return (
    <Button
      label={t('Search')}
      type="action"
      disabled={isDisabled || isFetching}
      onClick={(e) => {
        e.preventDefault()
        handleClick()
      }}
      icon={isLoading || isFetching ? loadingIcon : null}
    />
  )
}

export default SearchButton
